import { Details } from './Details'

export { default as Downloads } from './Downloads'
export { default as InvestorInfo } from './InvestorInfo'
export { default as ProblemsSolved } from './ProblemsSolved'
export { default as Teams } from './Teams'
export { default as UseOfFunds } from './UseOfFunds'
export { default as Lock } from './Lock'

export default Details